<template>
  <Anchor
    :item="item.link"
    class="b-vehicle-flexdrive"
    :class="{ 'is-electric': isElectric }">
    <div class="b-vehicle-flexdrive__offer">
      <LazyImage
        v-if="item.offerImageBackground"
        :image="item.offerImageBackground" />
      <div v-if="item.isNew" class="e-new lottie">
        <NewLottie width="20" />
      </div>
      <div v-if="item.offerText" class="b-vehicle-flexdrive__offer-text">
        {{ item.offerText }}
      </div>
    </div>
    <div class="b-vehicle-flexdrive__body">
      <div class="b-vehicle-flexdrive__main">
        <div class="b-vehicle-flexdrive__picture mb-30">
          <LazyImage v-if="image" :image="image" />
        </div>
        <div v-if="item.highlightText" class="b-vehicle-flexdrive__tagged">
          <div class="line"></div>
          <div class="title">{{ item.highlightText }}</div>
          <div class="line"></div>
        </div>
        <div v-else class="b-vehicle-flexdrive__tagged"></div>
        <div class="b-vehicle-flexdrive__header mb-40">
          <div v-if="isElectric" class="b-tech__leaf">
            <img src="/imgs/icons/leaf@2x.png" alt="Leaf" />
          </div>
          <div class="b-vehicle-flexdrive__title h4 extrabold">
            {{ item.make }} {{ item.model }}
            <span v-if="!item.isGuaranteed">
              {{ dictionary.orSimilarText }}
            </span>
          </div>
          <div class="b-vehicle-flexdrive__details">
            <ul>
              <li v-if="item.modelDescription">
                <div class="semibold">
                  {{ dictionary.vehicleModelLabel }} {{ item.modelDescription }}
                </div>
              </li>

              <li v-if="item.transmissionType">
                <div class="semibold">
                  <span>
                    {{ item.transmissionType }}
                  </span>
                </div>
              </li>

              <li v-if="item.fuel" :class="{ 'is-electric': isElectric }">
                <div class="semibold">
                  {{ item.fuel }}
                </div>
              </li>

              <li v-if="consumption">
                <div class="semibold">{{ item.consumption }} lt/100km</div>
              </li>

              <li v-if="drivingRange > 0">
                <div class="semibold">
                  {{ dictionary.vehicleDrivingRangePrefix }}
                  {{ item.drivingRange.toLocaleString(lang) }}
                  {{ dictionary.vehicleDrivingRangeSuffix }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="b-vehicle-flexdrive__footer">
          <div class="b-vehicle-flexdrive__totals mb-20">
            <div class="b-vehicle-flexdrive__price-w-vat">
              <div class="bold mb-5">
                <span>{{ dictionary.vehiclePricePrefix }}&nbsp;</span>
                <!-- prettier-ignore -->
                <span v-if="item.startingPricePerMonthInteger  && !vatIncluded" class="e-discount-price">€{{ item.startingPricePerMonthInteger.toLocaleString(lang) }}</span>
                <!-- prettier-ignore -->
                <span v-if="item.startingPricePerMonthInclVatInteger  && vatIncluded" class="e-discount-price">€{{ item.startingPricePerMonthInclVatInteger.toLocaleString(lang) }}</span>
                <span v-if="item.startingPricePerMonthInteger">&nbsp;</span>
                <span :class="{ 'is-active': vatIncluded }">
                  <!-- prettier-ignore -->
                  <em v-if="vatIncluded" >€{{ item.pricePerMonthInclVatInteger.toLocaleString(lang) }}</em>
                  <!-- prettier-ignore -->
                  <em v-else>€{{ item.pricePerMonthInteger.toLocaleString(lang) }}</em>
                </span>
                <span :class="{ 'is-active': vatIncluded }">
                  {{ dictionary.vehiclePriceSuffix }}
                </span>
              </div>

              <div class="form-check form-switch">
                <label
                  class="form-check-label"
                  :class="{ 'is-active': vatIncluded }"
                  :for="'vat' + item.id">
                  <span v-if="vatIncluded">
                    {{ dictionary.vehicleVatIncluded }}
                  </span>
                  <span v-else>{{ dictionary.vehicleVatExcluded }}</span>
                </label>
                <input
                  v-if="!isDisabled"
                  :id="'vat' + item.id"
                  v-model="vatIncluded"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  @click="preventPropagation" />
              </div>
            </div>
            <div class="e-arrow-button">
              <i class="icon-arrow-long-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Anchor>
</template>

<script>
import Anchor from './../components/common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
import * as lib from './../../lib/lib'
import constants from './../../lib/constants'
import NewLottie from './../components/lotties/New.vue'

export default {
  components: { Anchor, LazyImage, NewLottie },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      vatIncluded: false,
      lang: 'en',
    }
  },
  computed: {
    isElectric() {
      return this.item.fuelPreValue === constants.flexdrive.fuelType.electic
    },
    emissions() {
      if (!this.item.emissions || parseInt(this.item.emissions) <= 0) {
        return false
      }
      return true
    },
    consumption() {
      if (!this.item.consumption || parseInt(this.item.consumption) <= 0) {
        return false
      }
      return true
    },
    drivingRange() {
      return this.item.drivingRange && parseInt(this.item.drivingRange) > 0
    },
    isDisabled() {
      return !this.item.pricePerMonthInclVat
    },
    image() {
      const images = this.item.images
      if (!images.length) {
        return null
      }
      return {
        url: images[0].url,
        alt: '',
      }
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
  methods: {
    preventPropagation(event) {
      event.stopPropagation()
    },
  },
}
</script>
